import axios from "../../axios";
import { toast } from "react-toastify";
import { GET_TAX_GROUP } from "../types";

export const getTaxGroup = (params) => async (dispatch) => {
    try {
      // const res = await axios.get('/taxgroup/all', {params});
      
      const res = await axios.get(`${process.env.REACT_APP_ADMIN_URL}/taxgroup/all`, {params});
  
      if (res.data.code === 1) {
        dispatch({ type: GET_TAX_GROUP, payload: res.data.data });
      } 
    } catch (err) {
      if(err.response.data.errors[0].message){
        toast.error(err.response.data.errors[0].message);
      }
      // console.error("Failed to get Hsn. Please try again. :", err);
    }
};
